import type { IFieldConfiguration } from '@sravni/cosago-react-library/lib/types';

import { WorkAddressField } from 'shared/ui/AddressFields/WorkAddressField/WorkAddressField';

import type { TWorkplaceFormFields } from 'entities/creditForm';

import {
  AnotherUnemploymentReason,
  EmploymentType,
  UnemploymentReason,
  MonthlySalary,
  EmployerType,
  AreaOfEmployment,
  WorkPhone,
  JobTitle,
  EmployerInn,
  LastWorkExperienceStartMonth,
  WorkOrganizationName,
} from './ui/fields';

export interface IWorkplaceInfoMobileConfig extends Omit<IFieldConfiguration, 'fieldName'> {
  fieldName: keyof TWorkplaceFormFields;
}

export const FormFieldsControls: Record<keyof TWorkplaceFormFields, React.ReactNode> = {
  employmentType: EmploymentType,
  unemploymentReason: UnemploymentReason,
  anotherUnemploymentReason: AnotherUnemploymentReason,
  monthlySalary: MonthlySalary,
  employerType: EmployerType,
  areaOfEmployment: AreaOfEmployment,
  workPhone: WorkPhone,
  jobTitle: JobTitle,
  employerInn: EmployerInn,
  lastWorkExperienceStartMonth: LastWorkExperienceStartMonth,
  workAddress: WorkAddressField,
  isWorkOrganizationManuallyFilled: null,
  workOrganizationName: WorkOrganizationName,
  workLocationRoute: null,
  okved: null,
};

export const FormFieldsNavigationSequence: IWorkplaceInfoMobileConfig[] = [
  {
    fieldName: 'employmentType',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'unemploymentReason',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'anotherUnemploymentReason',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'monthlySalary',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'employerType',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'areaOfEmployment',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'workPhone',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'jobTitle',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'employerInn',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'lastWorkExperienceStartMonth',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'workAddress',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'workOrganizationName',
    required: false,
    checkShouldMoveToNextField: false,
  },
];
